module Meevo.Plugins.FameAdvantage {
    import SecurityParts = Meevo.Components.Common.SecurityParts;

    export class FameAdvantageContext extends Meevo.Components.CommonClasses.CommonContextBase {

        public get baseEndpoint(): string {
            return this.appSettings.API_ENDPOINTS.fameAdvantage;
        }

        public get sectionTemplatePath(): string {
            return 'app/plugins/fameAdvantage/sectionViews/';
        }

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected fameAdvantageApi: Meevo.Plugins.FameAdvantage.IFameAdvantageApi,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityChecker: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Components.Tracking.ITrackingService,
                    private $rootScope: angular.IRootScopeService,
                    private $state: ng.ui.IStateService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected dataConverter: Meevo.Components.Common.IDataConverterService,
                    protected dataExportService: Meevo.Components.Common.IDataExportService,
                    protected $translate: ng.translate.ITranslateService,
                    protected $filter: ng.IFilterService,
                    protected $scope: ng.IScope
        ) {
            super(appSettings, fameAdvantageApi, modalService, identityService, loggingService, securityChecker, trackingService);

            this.initializeSections();
        }

        public initializeSections() {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_FAMEADVANTAGE_TAB_SETTINGS + SecurityParts.KEY_PART_READ)) {
                this.sections.push(new SettingsSection(
                    0,
                    'SECTION_SETTINGS',
                    'settings.html',
                    true,
                    false,
                    this.baseEndpoint,
                    'FameAdvantageSettings',
                    this.loggingService,
                    this.fameAdvantageApi,
                    Meevo.Model.NounEnum.FameAdvantageSettingsTab,
                    this.identityService,
                    this.securityKeys.INTEGRATION_FAMEADVANTAGE_TAB_SETTINGS + SecurityParts.KEY_PART_READ,
                    this.modalService,
                    this.busyService,
                ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_FAMEADVANTAGE_TAB_STUDENTIMPORT + SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ImportSection(
                    1,
                    'SECTION_STUDENT_IMPORT',
                    'import.html',
                    false,
                    true,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.fameAdvantageApi,
                    Meevo.Model.NounEnum.FameAdvantageStudentImportTab,
                    this.identityService,
                    this.securityKeys.INTEGRATION_FAMEADVANTAGE_TAB_STUDENTIMPORT + SecurityParts.KEY_PART_READ,
                    this.modalService,
                    this.busyService,
                ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.INTEGRATION_FAMEADVANTAGE_TAB_TIMECLOCKEXPORT + SecurityParts.KEY_PART_READ)) {
                this.sections.push(new TimeClockSection(
                    2,
                    'SECTION_TIMECLOCK_EXPORT',
                    'timeclock.html',
                    false,
                    true,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.fameAdvantageApi,
                    Meevo.Model.NounEnum.FameAdvantageTimeclockExportTab,
                    this.identityService,
                    this.securityKeys.INTEGRATION_FAMEADVANTAGE_TAB_TIMECLOCKEXPORT + SecurityParts.KEY_PART_READ,
                    this.busyService,
                    this.dataExportService,
                    this.$translate,
                    this.$filter,
                    this.modalService,
                    this.$rootScope,
                    this.appSettings,
                    this.$state,
                    this.$scope
                ));
            }
        }

        public initializeHeader() {
            this.headerContent = 'HEADER_FAME_ADVANTAGE_INTEGRATION';
        }

        public selectSection(item): void {
            switch (item.sectionId) {
                case 0:
                    this.buildCrudSecurityKeysBase(this.securityKeys.INTEGRATION_FAMEADVANTAGE_TAB_SETTINGS);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.INTEGRATION_FAMEADVANTAGE);
                    break;
            }
            super.selectSection(item);
        }

        public closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }
    }
}
